class Tab extends HTMLElement {
  constructor() {
    super();
    this.radioButton = this.querySelector('input[type="radio"');

    if (!this.radioButton) return;

    this.parent = this.closest('tab-control');
    if (!this.parent) return;

    this.targetBody = this.parent.querySelector(`#${this.getAttribute('aria-controls')}`);

    this.update();
    this.radioButton.addEventListener('change', this.stateChangeHandler.bind(this));
  }

  stateChangeHandler(e) {
    this.update();
    this.dispatchEvent(new CustomEvent('checkChanged'));
  }

  //selects/unselects a tab
  update() {
    this.setAttribute('aria-selected', this.radioButton.checked);
    this.checked = this.radioButton.checked;

    if (this.radioButton.checked) {
      this.targetBody.setAttribute('open', '');
    } else this.targetBody.removeAttribute('open');
  }

  select() {
    this.radioButton.checked = true;
    this.stateChangeHandler();
  }

  unselect() {
    this.radioButton.checked = false;
    this.stateChangeHandler();
  }
}

customElements.define('control-tab', Tab);

class TabControl extends HTMLElement {
  constructor() {
    super();
    //get all tab buttons
    this.tabElements = Array.from(this.querySelectorAll('control-tab'));
    if (!this.tabElements || this.tabElements.length == 0) return;

    this.checkStateChangeHandler = this.checkStateChange.bind(this);

    this.initControlTabCheckChangeEventListeners();
    this.listenToWindowResize();
  }

  checkStateChange(e) {
    if (this.currentTab) this.currentTab.update(); //unselects last selected tab

    this.currentTab = e.target; //set currentTab variable to the most recent selected tab
  }

  listenToWindowResize() {
    window.addEventListener(
      'resize',
      debounce((event) => {
        this.onResize();
      }, 300).bind(this)
    );
    //on page load, first tab panel should be open on desktop
    if (window.innerWidth > 749) {
      this.currentTab = this.tabElements.filter((tab) => tab.checked)[0];
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  }

  onResize() {
    if (window.innerWidth < 750 && !this.isMobile) {
      this.foldAll();
      this.isMobile = true;
    }

    if (window.innerWidth > 749 && this.isMobile) {
      this.foldAll();
      this.tabElements[0].select(); //keep 1 tab panel open on desktop. (first tab panel)
      this.isMobile = false;
    }
  }

  //fold all details disclosure element, uncheck all radio buttons
  foldAll() {
    this.tabElements.forEach((tab) => {
      tab.unselect();
    });
  }

  initControlTabCheckChangeEventListeners() {
    this.tabElements.forEach((tab) => {
      tab.addEventListener('checkChanged', this.checkStateChangeHandler);
    });
  }
}

customElements.define('tab-control', TabControl);
